export default __webpack_public_path__ + "static/media/Highlord's Pendant of Shielding.beb924fb.jpg";